import { render, staticRenderFns } from "./ContestResultsDetails.vue?vue&type=template&id=17a91320"
import script from "./ContestResultsDetails.vue?vue&type=script&lang=js"
export * from "./ContestResultsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports